function getHotelStoreObject(hotel) {
  return Object.keys(hotel)
    .filter(
      (key) =>
        [
          "name",
          "countryCode",
          "currencyCode",
          "hotelCode",
          "accountStatus",
          "policies",
          "templates",
          "rooms",
          "rates",
          "settings",
        ].indexOf(key) >= 0
    )
    .reduce(
      (obj, key) =>
        Object.assign(obj, {
          [key]: hotel[key],
        }),
      {}
    );
}

export { getHotelStoreObject };
